export const SIZES = {
  topBar: {
    height: {
      small: 56,
      large: 80,
    },
  },
  navigationChange: 1280, // xl breakpoint
  layout: {
    width: {
      xs: 700,
      sm: 900,
      md: 1200,
      lg: 1400,
      xl: 1500,
    },
  },
};

export const LINKS = {
  LOG_IN: 'https://minside.scoopr.no/',
  FACEBOOK: 'https://www.facebook.com/Scoopr-103103178189677/',
  TIKTOK: 'https://www.tiktok.com/@scoopr.no',
  GJELDSREGISTERET: 'https://gjeldsregisteret.no',
  TRUST_PILOT: 'https://no.trustpilot.com/review/scoopr.no',
};
